import { isDefined } from "@clipboard-health/util-ts";
import { useToast } from "@src/appV2/lib";
import { APP_V2_USER_EVENTS, logError } from "@src/appV2/lib/analytics";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";

import {
  useWorkBadgeReviewPolicy,
  WorkBadgeReviewPolicyStep,
} from "../../hooks/useWorkBadgeReviewPolicy";
import { WorkBadgeSelectHeadshot } from "../WorkBadgeSelectHeadshot";
import { WorkBadgesReady } from "../WorkBadgesReady";
import { WorkBadgeReviewPolicy } from "./WorkBadgeReviewPolicy";

export function WorkBadgeReviewPolicyPage() {
  const {
    step,
    setStep,
    workerHeadshotBase64,
    setWorkerHeadshotBase64,
    qualificationName,
    handleClose,
    primaryButtonText,
  } = useWorkBadgeReviewPolicy();

  const { showErrorToast } = useToast();

  return (
    <PageWrapper variant="tertiary">
      {step === WorkBadgeReviewPolicyStep.REVIEW_POLICY && (
        <WorkBadgeReviewPolicy
          onClose={handleClose}
          onNeedNewBadge={() => {
            // This should never happen, we always pass qualificationName
            if (!qualificationName) {
              logError(APP_V2_USER_EVENTS.WORK_BADGE_REVIEW_POLICY_QUALIFICATION_NAME_NOT_DEFINED, {
                error: new Error("Qualification name not defined"),
              });
              showErrorToast("We're having trouble loading your badge. Please try again.");
              handleClose();
              return;
            }

            setStep(WorkBadgeReviewPolicyStep.SELECT_HEADSHOT);
          }}
        />
      )}

      {step === WorkBadgeReviewPolicyStep.SELECT_HEADSHOT && isDefined(qualificationName) && (
        <WorkBadgeSelectHeadshot
          qualificationName={qualificationName}
          onConfirm={(newWorkerHeadshotBase64) => {
            setWorkerHeadshotBase64(newWorkerHeadshotBase64);
            setStep(WorkBadgeReviewPolicyStep.BADGE_READY);
          }}
          onBack={() => {
            setStep(WorkBadgeReviewPolicyStep.REVIEW_POLICY);
          }}
        />
      )}

      {step === WorkBadgeReviewPolicyStep.BADGE_READY &&
        isDefined(workerHeadshotBase64) &&
        isDefined(qualificationName) && (
          <WorkBadgesReady
            qualificationName={qualificationName}
            workerHeadshotBase64={workerHeadshotBase64}
            emailSuccessModal={{
              primaryButtonText,
              onPrimaryButtonClick: handleClose,
            }}
            onBack={() => {
              setStep(WorkBadgeReviewPolicyStep.SELECT_HEADSHOT);
            }}
          />
        )}
    </PageWrapper>
  );
}
